import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    useChartsData,
    QUERY_KEYS_SIH
} from '../../../../Common/hooks/useChartsData';
import { subtitlesMap } from '../../../Common/maps/subtitleMap';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.TOTAL_UTILIZATION_MONTH,
            url: 'governanceroom/dashboard/sihsus/aih/utilizationUti'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData = data
        ? {
              averageCounterYear: data.averageCounterYear || [],
              averageSelectedYear: data.averageSelectedYear || []
          }
        : {
              averageCounterYear: [],
              averageSelectedYear: []
          };

    const colors = ["#1F77B4", "#FF7F0E"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
